import React from 'react';
import { Paperclip, Trash2 } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import {
  ATTACHMENT_ACCEPT,
  formatFileSize,
  validateAttachmentFile,
} from '../../services/attachments';

const StagedAttachmentPicker = ({ files, onChange, disabled = false, progress = {} }) => {
  const handleFiles = (event) => {
    const selected = Array.from(event.target.files || []);
    const valid = [];
    selected.forEach(file => {
      const error = validateAttachmentFile(file);
      if (error) toast.error(`${file.name}: ${error}`);
      else valid.push(file);
    });

    if (valid.length > 0) {
      const existingKeys = new Set((files || []).map(file => `${file.name}:${file.size}:${file.lastModified}`));
      onChange([...(files || []), ...valid.filter(file => !existingKeys.has(`${file.name}:${file.size}:${file.lastModified}`))]);
    }
    event.target.value = '';
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="task-attachments">ATTACHMENTS</Label>
      <Input
        id="task-attachments"
        type="file"
        multiple
        accept={ATTACHMENT_ACCEPT}
        onChange={handleFiles}
        disabled={disabled}
        data-testid="task-attachments-input"
      />
      <p className="text-[10px] text-muted-foreground">Documents and images, up to 25 MiB per file.</p>
      {(files || []).length > 0 && (
        <div className="space-y-1.5">
          {files.map((file, index) => {
            const fileProgress = progress[index];
            return (
              <div key={`${file.name}-${file.size}-${file.lastModified}`} className="p-2 border border-border space-y-1">
                <div className="flex items-center gap-2">
                  <Paperclip className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
                  <span className="text-xs truncate flex-1">{file.name}</span>
                  <span className="text-[10px] text-muted-foreground shrink-0">{formatFileSize(file.size)}</span>
                  {!disabled && (
                    <Button
                      type="button"
                      variant="ghost"
                      size="icon"
                      className="h-6 w-6"
                      onClick={() => onChange(files.filter((_, fileIndex) => fileIndex !== index))}
                      aria-label={`Remove ${file.name}`}
                    >
                      <Trash2 className="h-3 w-3" />
                    </Button>
                  )}
                </div>
                {typeof fileProgress === 'number' && (
                  <div className="h-1.5 bg-muted overflow-hidden" role="progressbar" aria-valuenow={fileProgress} aria-valuemin="0" aria-valuemax="100">
                    <div className="h-full bg-primary transition-all" style={{ width: `${fileProgress}%` }} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StagedAttachmentPicker;
